'use es6';

export default function templateErrorIsMissingTemplate(templatePath) {
  return e => {
    return (e.severity === 'FATAL' || e.severity === 'WARNING') && e.reason === 'MISSING' && e.message.match(/^Missing template/i) && e.categoryErrors && e.categoryErrors.path === templatePath;
  };
}